export const EmployeeHealthOptions = [
    { name: 'EmployeeInjury', description: 'Employee Injury' },
    { name: 'EmployeeExposure', description: 'Employee Exposure' },
    { name: 'EmployeeIllness', description: 'Employee Illness' },
    { name: 'ProviderVendorInjury', description: 'Provider/Vendor Injury' },
    { name: 'ProviderVendorExposure', description: 'Provider/Vendor Exposure' },
    { name: 'ProviderIllness', description: 'Provider Illness' },
    { name: 'Other', description: 'Other' },
];
